import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useFeatureFlag } from '../../_augmentt/services/featureFlags'

/**
 * Hook to return authorization flags
 */
const useAuthorization = () => {
  const selectedCustomer = useSelector(({ customers }) => customers?.selectedCustomer)

  // org subscriptions
  const hasEngageAutopilotSubscription = useSelector(({ meta }) => meta.hasEngageAutopilotSubscription)
  const hasIntuneSubscription = useSelector(({ meta }) => meta.hasIntuneSubscription)
  const hasValidPostureBaselineSubscription = useSelector(({ meta }) => meta.hasValidPostureBaselineSubscription)

  // nfr licenses
  const hasNfrEngageEssentialsLicense = selectedCustomer?.hasNfrEngageEssentialsLicense
  const hasNfrSecureEssentialsLicense = selectedCustomer?.hasNfrSecureEssentialsLicense

  // licenses
  const licenses = useSelector((state) => state.licenses.data)

  const hasLicenses = useCallback(
    (licenseNames) => licenseNames.some((name) => licenses?.[name]?.hasLicense),
    [licenses],
  )

  // feature flags
  const isEngageAutopilotFlagEnabled = useFeatureFlag('engage-autopilot')
  const isEntraIdGroupsEnabled = useFeatureFlag('entra-id-groups')

  return {
    isAuthorizedForEngageAutopilot:
      isEngageAutopilotFlagEnabled && (hasEngageAutopilotSubscription || hasNfrEngageEssentialsLicense),
    isAuthorizedForIntune: hasIntuneSubscription || hasNfrSecureEssentialsLicense,
    isAuthorizedForDiscover: hasLicenses(['discover-essentials', 'discover-premium', 'nfr-discover-essentials']),
    isAuthorizedForGroups: isEntraIdGroupsEnabled && hasValidPostureBaselineSubscription,
  }
}

export default useAuthorization
